import NotFound from '@/pages/404'
import { Navigate, useRoutes } from 'react-router-dom'

import { publicRoutes } from './public'
import { PATH_AFTER_LOGIN } from '../paths'
import { protectedRoutes } from './protected'

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },
    ...publicRoutes,
    ...protectedRoutes,
    { path: '*', element: <NotFound /> },
  ])
}
